goog.provide("shadow.js.shim.module$ol$format$GeoJSON");
goog.provide("module$shadow_js_shim_module$ol$format$GeoJSON");
shadow.js.shim.module$ol$format$GeoJSON = shadow.js.nativeProvides["ol/format/GeoJSON"] = shadow$bridge("ol/format/GeoJSON");
module$shadow_js_shim_module$ol$format$GeoJSON.default = shadow.js.shim.module$ol$format$GeoJSON;
